function AppVersion() {
  return (
    <div style={{ position: "fixed", bottom: 20, left: 10 }}>
      App version: {process.env.REACT_APP_VERSION}
    </div>
  );
}

export default AppVersion;
